import { compose } from "redux";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../../models/Action";
import { immutableSet } from "../../../../utils/immutable";
import { actionTypes } from "./actions";
import emptyState from "./emptyState";

import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";
import { IDENTITY_SYSTEM } from "../../../../module/constants";
import {
  CatalogSegregationConfigurationItem,
  CatalogSegregationEnrichment,
} from "../../../../models/Catalog";

const {
  OFFICES,
  SELECTED_OFFICE,
  SHOW_ADVANCED_FILTER,
  SELECTED_USERS,
  SELECTED_ENTITLEMENTS,
  IS_POSSIBLE_TO_CONTINUE,
  LOADER_LIST_IDENTIFIER,
  LIST_ENTITLEMENTS,
  TOTAL_ENTITLEMENTS,
  ADDED_ENTITLEMENTS,
  DELETED_ENTITLEMENTS,
  MODIFIED_ENTITLEMENTS,
  PREV_ENTITLEMENTS,
  CHAIN_ENTITLEMENTS,
  CALL_STATE,
  STEP_ONE,
  STEP_TWO,
  USERS_LIST,
  SELECTED_CATALOG,
  START_END_DATE,
  SEGREGATIONS,
  ENRICHMENTS,
  UPDATED_SEGREGATION,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_PAGINATION_TABLE_STEP_ONE]: (state: any, action: any) =>
    immutableSet([STEP_ONE, LOADER_IDENTIFIER], true, state),

  [actionTypes.GET_PAGINATION_TABLE_STEP_ONE_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let modifiedOus: any[] = [];
    let { ous, ...paginationData } = action.payload;
    ous.forEach((ou: any) => {
      let modifiedOu = {
        uniqueId: ou.id,
        ouCode: ou.code,
        name: ou.name,
        description: ou.description,
        owner: ou.owner,
        properties: ou.properties,
        identitySystemId:
          IDENTITY_SYSTEM[ou.identitySystemId as keyof typeof IDENTITY_SYSTEM],
      };
      modifiedOus.push(modifiedOu);
    });
    let modifiedPayload = {
      ...paginationData,
      ous: modifiedOus,
    };
    return compose(
      immutableSet([STEP_ONE, LIST_IDENTIFIER], modifiedPayload),
      immutableSet([STEP_ONE, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_PAGINATION_TABLE_STEP_ONE_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([STEP_ONE, LOADER_IDENTIFIER], false, state),

  [actionTypes.GET_PAGINATION_TABLE_STEP_TWO]: (state: any, action: any) =>
    immutableSet([STEP_TWO, LOADER_IDENTIFIER], true, state),

  [actionTypes.GET_PAGINATION_TABLE_STEP_TWO_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let modifiedUsers: any[] = [];
    let { users, ...paginationData } = action.payload;
    users.forEach((user: any) => {
      let modifiedUser = {
        uniqueId: user.id,
        code: user.code,
        name: user.name,
        surname: user.surname,
        organizational_unit_code: user.organizational_unit_code,
        type: user.type,
        company: user.company,
        identitySystemId:
          IDENTITY_SYSTEM[
            user.identitySystemId as keyof typeof IDENTITY_SYSTEM
          ],
      };
      modifiedUsers.push(modifiedUser);
    });
    let modifiedPayload = {
      ...paginationData,
      users: modifiedUsers,
    };
    return compose(
      immutableSet([STEP_TWO, USERS_LIST], modifiedPayload),
      immutableSet([STEP_TWO, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.HIDE_OU]: (state: any, action: any) =>
    immutableSet([STEP_TWO, CALL_STATE], IResponseState.PENDING, state),

  [actionTypes.HIDE_OU_SUCCESS]: (state: any, action: any) =>
    immutableSet([STEP_TWO, CALL_STATE], IResponseState.SUCCESS, state),

  [actionTypes.HIDE_OU_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_TWO, CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.SHOW_OU]: (state: any, action: any) =>
    immutableSet([STEP_TWO, CALL_STATE], IResponseState.PENDING, state),

  [actionTypes.SHOW_OU_SUCCESS]: (state: any, action: any) =>
    immutableSet([STEP_TWO, CALL_STATE], IResponseState.SUCCESS, state),

  [actionTypes.SHOW_OU_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_TWO, CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.SET_SELECTED_CATALOG]: (state: any, action: any) => {
    return compose(
      immutableSet([STEP_TWO, SELECTED_CATALOG], action.payload),
      immutableSet([SELECTED_OFFICE], action.payload.uniqueId)
    )(state);
  },
  [actionTypes.SELECT_CATALOG_OFFICE]: (state: any, action: any) =>
    immutableSet([SELECTED_OFFICE], action.id, state),
  [actionTypes.MODIFY_CATALOG_SELECTED_USERS]: (state: any, action: any) =>
    immutableSet([SELECTED_USERS], action.selectedUsers, state),
  [actionTypes.MODIFY_CATALOG_DELETED_ENTITLEMENTS]: (
    state: any,
    action: any
  ) => immutableSet([DELETED_ENTITLEMENTS], action.deletedEntitlements, state),
  [actionTypes.MODIFY_CATALOG_TOTAL_ENTITLEMENTS]: (state: any, action: any) =>
    immutableSet([TOTAL_ENTITLEMENTS], action.totalEntitlements, state),
  [actionTypes.ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          entitlement_id: data.entitlement_id,
          application_name: data.application_name,
          application_description: data.application_description,
          entitlement_name: data.entitlement_name,
          entitlement_description: data.entitlement_description,
          editable: data.editable,
          deleted: false,
          added: false,
          validable: data.validable,
          chainEntitlementsIds: data.chainEntitlementsIds,
          identitySystemId:
            IDENTITY_SYSTEM[
              data.identity_system_id as keyof typeof IDENTITY_SYSTEM
            ],
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet([TOTAL_ENTITLEMENTS], mappedResponse),
      immutableSet([PREV_ENTITLEMENTS], mappedResponse)
    )(state);
  },
  [actionTypes.ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([LOADER_LIST_IDENTIFIER], true, state),

  [actionTypes.ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        if (Array.isArray(data)) {
          const tempRow: {} = {
            entitlement_id: data[0].codeBusinessRole,
            application_name: data[0].name,
            application_description: data[0].description,
            entitlement_name: "",
            entitlement_description: "",
          };
          mappedResponse.push(tempRow);
        } else {
          const tempRow: {} = {
            entitlement_id: data.entitlement_id,
            application_name: data.application_name,
            application_description: data.application_description,
            entitlement_name: data.entitlement_name,
            entitlement_description: data.entitlement_description,
            editable: data.editable,
            deleted: false,
            added: false,
            validable: data.validable,
            chainEntitlementsIds: data.chainEntitlementsIds,
            identitySystemId:
              IDENTITY_SYSTEM[
                data.identity_system_id as keyof typeof IDENTITY_SYSTEM
              ],
          };
          mappedResponse.push(tempRow);
        }
      });
    return compose(
      immutableSet([LIST_ENTITLEMENTS], mappedResponse),
      immutableSet([LOADER_LIST_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([LIST_ENTITLEMENTS], []),
      immutableSet([LOADER_LIST_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.ADMIN_GLOBAL_CATALOG_REQUEST]: (state: any) =>
    immutableSet([LOADER_LIST_IDENTIFIER], true, state),

  [actionTypes.ADMIN_GLOBAL_CATALOG_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let { entitlements, ...paginationData } = action.payload;

    let mappedResponse: any[] = [];
    entitlements.length > 0 &&
      entitlements.forEach((data: any) => {
        if (Array.isArray(data)) {
          const tempRow: {} = {
            entitlement_id: data[0].codeBusinessRole,
            application_name: data[0].name,
            application_description: data[0].description,
            entitlement_name: "",
            entitlement_description: "",
          };
          mappedResponse.push(tempRow);
        } else {
          const tempRow: {} = {
            entitlement_id: data.entitlement_id,
            application_name: data.application_name,
            application_description: data.application_description,
            entitlement_name: data.entitlement_name,
            entitlement_description: data.entitlement_description,
            editable: data.editable,
            deleted: false,
            added: false,
            validable: data.validable,
            chainEntitlementsIds: data.chainEntitlementsIds,
            identitySystemId:
              IDENTITY_SYSTEM[
                data.identity_system_id as keyof typeof IDENTITY_SYSTEM
              ],
          };
          mappedResponse.push(tempRow);
        }
      });

    const fineResponse = { ...paginationData, entitlements: mappedResponse };

    return compose(
      immutableSet([LIST_ENTITLEMENTS], fineResponse),
      immutableSet([LOADER_LIST_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.ADMIN_GLOBAL_CATALOG_REQUEST_FAILURE]: (state: any) =>
    compose(
      immutableSet([LIST_ENTITLEMENTS], []),
      immutableSet([LOADER_LIST_IDENTIFIER], false)
    )(state),

  [actionTypes.ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([TOTAL_ENTITLEMENTS], action, state),

  [actionTypes.ADMIN_OFFICE_CATALOG_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([OFFICES], action.payload, state),

  [actionTypes.ADMIN_OFFICE_CATALOG_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([OFFICES], action, state),

  [actionTypes.ADMIN_CHAIN_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CHAIN_ENTITLEMENTS], action.payload, state),

  [actionTypes.ADMIN_CHAIN_ENTITLEMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CHAIN_ENTITLEMENTS], action, state),

  [actionTypes.MODIFY_CATALOG_PREV_ENTITLEMENTS]: (state: any, action: any) =>
    immutableSet([PREV_ENTITLEMENTS], action.prevEntitlements, state),
  [actionTypes.MODIFY_CATALOG_ADDED_ENTITLEMENTS]: (state: any, action: any) =>
    immutableSet([ADDED_ENTITLEMENTS], action.addedEntitlements, state),
  [actionTypes.RESET_STATE_CATALOG]: (state: any, action: any) => emptyState,

  [actionTypes.ADMIN_CREATE_CATALOG_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),

  [actionTypes.ADMIN_CREATE_CATALOG_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),

  [actionTypes.ADMIN_CREATE_CATALOG_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.SAVE_ACTION]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),

  [actionTypes.SAVE_ACTION_SUCCESS]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.SUCCESS, state),

  [actionTypes.SAVE_ACTION_FAILURE]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.RESET_ADDED_REMOVED_ENTITLEMENTS]: (state: any, action: any) =>
    compose(
      immutableSet([DELETED_ENTITLEMENTS], []),
      immutableSet([ADDED_ENTITLEMENTS], [])
    )(state),

  [actionTypes.RESET_CHAIN_ENTITLEMENTS]: (state: any, action: any) =>
    immutableSet([CHAIN_ENTITLEMENTS], [], state),

  [actionTypes.CATALOG_SET_START_END_DATE]: (state: any, action: any) => {
    let obj = {
      id: action.payload.id,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    };

    let data: any[] = state.startEndDate;
    data.push(obj);
    return immutableSet([START_END_DATE], data, state);
  },
  [actionTypes.CATALOG_REMOVE_DATE]: (state: any, action: any) => {
    let original: any[] = state.startEndDate;
    let clean = original.filter((el) => el.id !== action.payload);

    return immutableSet([START_END_DATE], clean, state);
  },

  [actionTypes.GET_SEGREGATIONS_REQUEST]: (state: any) =>
    compose(
      immutableSet([SEGREGATIONS, LOADER_IDENTIFIER], true),
      immutableSet([SEGREGATIONS, ENRICHMENTS], []),
      immutableSet([SEGREGATIONS, LIST_IDENTIFIER], [])
    )(state),
  [actionTypes.GET_SEGREGATIONS_REQUEST_SUCCESS]: (state: any, action: any) => {
    let mappedResponse: CatalogSegregationConfigurationItem[] = [];
    let segregationEnrichments: CatalogSegregationEnrichment[] = [];
    if (action.payload && action.payload.attributes) {
      // DO SOMETHING
      action.payload.attributes.forEach(
        (attribute: CatalogSegregationEnrichment) =>
          segregationEnrichments.push(attribute)
      );

      segregationEnrichments = segregationEnrichments.sort((a, b) =>
        a.attributeName < b.attributeName ? -1 : 1
      );
    }
    if (
      action.payload &&
      action.payload.configurations &&
      segregationEnrichments.length > 0
    ) {
      action.payload.configurations.forEach(
        (
          config: Omit<CatalogSegregationConfigurationItem, "attributeName">
        ) => {
          const temp: CatalogSegregationConfigurationItem = {
            id: config.id,
            attributeId: config.attributeId,
            attributeName: segregationEnrichments.find(
              (enrich: CatalogSegregationEnrichment) =>
                enrich.id === config.attributeId
            )?.attributeName!,
            attributeValue: config.attributeValue,
            visibilityCone: config.visibilityCone,
          };
          mappedResponse.push(temp);
        }
      );
    }
    if (mappedResponse.length > 0) {
      mappedResponse = mappedResponse.sort((a, b) => (a.id < b.id ? -1 : 1));
    }
    return compose(
      immutableSet([SEGREGATIONS, LOADER_IDENTIFIER], false),
      immutableSet([SEGREGATIONS, ENRICHMENTS], segregationEnrichments),
      immutableSet([SEGREGATIONS, LIST_IDENTIFIER], mappedResponse)
    )(state);
  },
  [actionTypes.GET_SEGREGATIONS_REQUEST_FAILURE]: (state: any) =>
    compose(
      immutableSet([SEGREGATIONS, LOADER_IDENTIFIER], false),
      immutableSet([SEGREGATIONS, ENRICHMENTS], []),
      immutableSet([SEGREGATIONS, LIST_IDENTIFIER], [])
    )(state),

  [actionTypes.ADD_SEGREGATION_REQUEST]: (state: any) =>
    immutableSet([SEGREGATIONS, CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.ADD_SEGREGATION_REQUEST_SUCCESS]: (state: any) =>
    immutableSet([SEGREGATIONS, CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.ADD_SEGREGATION_REQUEST_FAILURE]: (state: any) =>
    immutableSet([SEGREGATIONS, CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.UPDATE_SEGREGATIONS_REQUEST]: (state: any) =>
    immutableSet([SEGREGATIONS, CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.UPDATE_SEGREGATIONS_REQUEST_SUCCESS]: (state: any) =>
    immutableSet([SEGREGATIONS, CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.UPDATE_SEGREGATIONS_REQUEST_FAILURE]: (state: any) =>
    immutableSet([SEGREGATIONS, CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.DELETE_SEGREGATIONS_REQUEST]: (state: any) =>
    immutableSet([SEGREGATIONS, CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.DELETE_SEGREGATIONS_REQUEST_SUCCESS]: (state: any) =>
    immutableSet([SEGREGATIONS, CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.DELETE_SEGREGATIONS_REQUEST_FAILURE]: (state: any) =>
    immutableSet([SEGREGATIONS, CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.SELECT_SEGREGATION]: (state: any, action: any) =>
    immutableSet([SEGREGATIONS, UPDATED_SEGREGATION], action.payload, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
